 

<app-header></app-header>
   
<section class="container-xxl">
    <div id="section-New"></div>
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Home':'होम'" routerLink="/">{{"Home"|translate}}</a></li>
                <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Video Category':'वीडियो श्रेणी'" routerLink="/videocategory">{{"videocategory"|translate}} </a></li>
                <li class="breadcrumb-item active screen-reader">{{videoCatNm==''?htmldecode(getTitle(categoryId)):htmldecode(videoCatNm) }}</li>
               
            </ol>
        </nav>
    </div>  
    <!-- BREADCRUMB AREA - ENDS -->
 
    <div class="inner-page"> 
        <div class="inner-page-details">
            <div class="row"> 
                <div class="col-lg-12"> 
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                              
                                <div class="details">
                                    <div class="title d-sm-flex justify-content-between align-items-center">
                                        <h2 class="screen-reader">{{videoCatNm==''?htmldecode(getTitle(categoryId)):htmldecode(videoCatNm) }}</h2>
                                        <!-- <a (click)="viewDetails(videoCatId,'archivevideogallery')"  href="javascript:void(0);" class="btn btn-sm btn-outline-success"><i class="bi bi-archive me-2"></i>{{'ArchiveVideoGallery' | translate}}</a> -->
                                    </div>
                                    <div class="description mb-4" *ngIf="catwiseGallery && catwiseGallery.length > 0; else noDataTemplate">
                                        <div class="info-box">
                                            <div class="videodetails">
                                                <div class="row videodetails-image-area" id="video-container">
                                            <ng-container *ngFor="let items of catwiseGallery">
                                                <ng-container *ngFor="let thum of items.addThumbnails">
                                                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-6 video-item mb-2 mb-md-4"  
                                                    [attr.data-responsive]="this.imageUrl+thum.uploadThumbnail"
                                                    [attr.data-src]="thum.videoURL" *ngIf="FileCheck(thum)">
                                                        <a href="javascript:;" [attr.title]="language=='English'?'Play':'चलाएं'">
                                                            <img [attr.alt]="items.title" class="videodetails-image"
                                                            [attr.src]="this.imageUrl+thum.uploadThumbnail">
                                                            <div class="middle">
                                                                <div class="text"><i class="bi bi-play-circle"></i></div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                       
                                    </div>
                                    <ng-template #noDataTemplate>
                           
                                        <p class="screen-reader font-adjust" [style.text-align]="'center'"><b>{{ "Norecordsfound" | translate }}</b></p>
                
                                      </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div> 

</section>

<app-clients></app-clients>

<app-footer></app-footer> 



